"use client";

import { normalizeDreamnOddsTrend } from "@/utils/dreamnOddsDisplayToggle";
import trendArrowDown from "@/assets/images/trend-arrow-down.svg";
import trendArrowUp from "@/assets/images/trend-arrow-up.svg";

const MASK_STYLE = (src, bg) => ({
  backgroundColor: bg,
  maskImage: `url(${src})`,
  WebkitMaskImage: `url(${src})`,
  maskSize: "contain",
  maskRepeat: "no-repeat",
  maskPosition: "center",
  WebkitMaskSize: "contain",
  WebkitMaskRepeat: "no-repeat",
  WebkitMaskPosition: "center",
});

export default function DreamnOddsTrendArrow({ trend }) {
  const n = normalizeDreamnOddsTrend(trend);
  if (n !== "increased" && n !== "decreased") return null;

  const up = n === "increased";
  const maskSrc = up ? trendArrowUp : trendArrowDown;
  const bg = up ? "#22AE95" : "#D62A40";

  return (
    <span
      className="dreamn-odds-trend-arrow inline-block h-3 w-3 shrink-0"
      style={MASK_STYLE(maskSrc, bg)}
      aria-hidden
    />
  );
}
